import { createStyles, makeStyles, Typography } from '@material-ui/core';
import { FormikProps } from 'formik';
import * as React from 'react';
import { TranquiTheme } from '../../containers/App/theme';
import RenderText from '../../dictionaries/RenderText';
import { NegotiationOption, OutDebt } from '../../generated/graphql';
import { getNegBooleans } from '../../utils/getNegBooleans';
import FormikCheck from '../FormikInputWrappers/FormikCheck';

interface AutoDebitCheckProps {
  negotiation?: NegotiationOption;
  formik?: FormikProps<any>;
  outDebt?: OutDebt;
}

const AutoDebitCheck: React.FC<AutoDebitCheckProps> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();
  const { negotiation, formik, outDebt } = props;

  const { isBbva } = getNegBooleans(outDebt, negotiation);
  if (!isBbva) return null;
  if (!formik) return null;

  return (
    <FormikCheck
      className="mb-n2"
      formik={formik}
      valueId="autoDebitCheck"
      iconClassName={classes.iconCheckBox}
      helperTextClassName="mb-2"
      labelCheck={(
        <Typography className={classes.checkBoxText}>
          <RenderText textKey="alert_autodebit_check_formik" />
        </Typography>
          )}
    />
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  checkBox: {
    padding: theme.spacing(-1, 0),
  },
  checkBoxText: {
    ...theme.typography.body2,
    color: theme.palette.indigo.main,
  },
  iconCheckBox: {
    width: '0.8em',
    height: '0.8em',
  },
}));

export default AutoDebitCheck;
